import React, { useContext, useEffect, useState } from 'react';
import * as R from 'ramda';
import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import {
  ErrorType,
  complianceErrors,
  disallowedCountryErrors,
  disallowedRegionErrors,
  getErrorType,
  partnerRejectedErrors,
  sessionExpiredErrors,
  suspiciousIpErrors,
  uniquenessErrors,
} from '../../utils/errors';
import UniquenessRejectedError from '../../common/components/Error/UniquenessRejectedError';
import { GatekeeperNetworkServiceContext } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';
import Loading from '../../common/components/Loading/Loading';
import { Screens } from '../../services/analytics/screens';

function TokenRejectedScreen(): JSX.Element {
  const { initialized, flowSuccessful, getOptionalFlowExecutionConfig } = useContext(FlowConfigContext);
  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);
  const partnerName: string = R.propOr(false, 'partnerName', gknServiceData);
  const [errorType, setErrorType] = useState<ErrorType>(ErrorType.TokenRejected);
  const [loading, setLoading] = useState(true);

  const onConfirm = () => {
    flowSuccessful();
  };

  useEffect(() => {
    if (!initialized) {
      return;
    }

    const providedErrorCode = getOptionalFlowExecutionConfig('errorCode');
    setErrorType(getErrorType(providedErrorCode || undefined));
    setLoading(false);
  }, [initialized]);

  return (
    <>
      {uniquenessErrors.includes(errorType) && <UniquenessRejectedError onConfirm={onConfirm} errorType={errorType} />}
      {loading && (
        <div className="document-fixed-height flex h-screen justify-center items-center">
          <Loading />
        </div>
      )}
      {partnerRejectedErrors.includes(errorType) && (
        <MessagePanel
          title="screens.partnerRejected.title"
          description="screens.partnerRejected.description"
          buttonLabel="screens.partnerRejected.buttonLabel"
          onConfirm={onConfirm}
          translationVariables={{ partnerName }}
          showSupportLink
        />
      )}
      {suspiciousIpErrors.includes(errorType) && (
        <MessagePanel
          title="screens.suspiciousIPCheck.title"
          description="screens.suspiciousIPCheck.description"
          buttonLabel="screens.suspiciousIPCheck.buttonLabel"
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
      {disallowedCountryErrors.includes(errorType) && (
        <MessagePanel
          title="screens.restrictedCountryDetected.title"
          description="screens.restrictedCountryDetected.description"
          buttonLabel="screens.restrictedCountryDetected.buttonLabel"
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
      {disallowedRegionErrors.includes(errorType) && (
        <MessagePanel
          title="screens.restrictedRegionDetected.title"
          description="screens.restrictedRegionDetected.description"
          buttonLabel="screens.restrictedRegionDetected.buttonLabel"
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
      {errorType === ErrorType.VpnDetected && (
        <MessagePanel
          title="screens.failedVPNCheck.title"
          description="screens.failedVPNCheck.description"
          buttonLabel="screens.failedVPNCheck.buttonLabel"
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
      {complianceErrors.includes(errorType) && (
        <MessagePanel
          title="screens.error.title_compliance_store_check_failed"
          description="screens.error.description_compliance_store_check_failed"
          buttonLabel="screens.error.closeButtonLabel"
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
      {errorType === ErrorType.IdentityTokenIpMismatch && (
        <MessagePanel
          title="screens.failedIdentityTokenIpCheck.title"
          description="screens.failedIdentityTokenIpCheck.description"
          buttonLabel="screens.tokenRejected.buttonLabel"
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
      {sessionExpiredErrors.includes(errorType) && (
        <MessagePanel
          title="screens.sessionExpired.title"
          description="screens.sessionExpired.description"
          buttonLabel="screens.tokenRejected.buttonLabel"
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
      {errorType === ErrorType.TokenRejected && !loading && (
        <MessagePanel
          title="screens.tokenRejected.title"
          description="screens.tokenRejected.description"
          buttonLabel="screens.tokenRejected.buttonLabel"
          translationVariables={{ partnerName }}
          onConfirm={onConfirm}
          showSupportLink
        />
      )}
    </>
  );
}
export default withRouteAnalytics(TokenRejectedScreen, Screens.TOKEN_REJECTED);
